import Vue from 'vue'

export default {
  UPDATE_SETTINGS: (state, payload) => Vue.set(state, 'settings', payload),
  SET_PREVIEW_MODE: (state, payload) => Vue.set(state.settings, 'preview', payload)
}
